import React from "react"
import { radioInfoText, radioLabelText } from "./RadioButton.css"

type Props = {
  inlineText?: string
  label?: string
  info?: string
}

export const RadioLabel: React.FC<Props> = ({ label, inlineText, info }) => (
  <>
    <div className={radioLabelText}>
      <span>{label}</span>
      {inlineText && <span>{inlineText}</span>}
    </div>
    <span className={radioInfoText}>{info}</span>
  </>
)
